import { createAction, props } from '@ngrx/store';
import { ITaxCertificateType } from '../models/tax-certificate-type.model';

export const loadGetTaxCertTypes = createAction('[GetTaxCertType] Load GetTaxCertTypes');

export const loadGetTaxCertTypesSuccess = createAction(
  '[GetTaxCertType] Load GetTaxCertTypes Success',
  props<{ response: ITaxCertificateType[] }>()
);

export const loadGetTaxCertTypesFailure = createAction('[GetTaxCertType] Load GetTaxCertTypes Failure', props<{ error: Error | any }>());
